import { render, staticRenderFns } from "./StockSourcePane.vue?vue&type=template&id=36c6dcd6"
import script from "./StockSourcePane.vue?vue&type=script&lang=js"
export * from "./StockSourcePane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c6dcd6')) {
      api.createRecord('36c6dcd6', component.options)
    } else {
      api.reload('36c6dcd6', component.options)
    }
    module.hot.accept("./StockSourcePane.vue?vue&type=template&id=36c6dcd6", function () {
      api.rerender('36c6dcd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/StockSourcePane.vue"
export default component.exports